import { render, staticRenderFns } from "./InformationInvolvedCard.vue?vue&type=template&id=393da609&"
import script from "./InformationInvolvedCard.vue?vue&type=script&lang=ts&"
export * from "./InformationInvolvedCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports